import { supabase } from './SupabaseConfig';
import { BranchRepository } from '@domain/pos/ports/BranchRepository';
import { InfrastructureError } from '@core/errors/AppError';

export class SupabaseBranchRepository implements BranchRepository {
  async getLocations(uid: string): Promise<any[]> {
    try {
      const { data, error } = await supabase
        .from('locations')
        .select('*')
        .eq('owner_id', uid)
        .order('name', { ascending: true });

      if (error) throw error;
      return data || [];
    } catch (error) {
      throw new InfrastructureError('Lỗi lấy danh sách chi nhánh', 'Supabase', error as Error);
    }
  }

  async addLocation(uid: string, data: any): Promise<string> {
    try {
      const { data: newLoc, error } = await supabase
        .from('locations')
        .insert({
          ...data,
          owner_id: uid,
          updated_at: new Date().toISOString()
        })
        .select()
        .single();

      if (error) throw error;
      return newLoc.id;
    } catch (error) {
      throw new InfrastructureError('Lỗi thêm chi nhánh mới', 'Supabase', error as Error);
    }
  }

  async updateLocation(uid: string, locationId: string, data: any): Promise<void> {
    try {
      const { error } = await supabase
        .from('locations')
        .update({
          ...data,
          updated_at: new Date().toISOString()
        })
        .eq('id', locationId)
        .eq('owner_id', uid);

      if (error) throw error;
    } catch (error) {
      throw new InfrastructureError('Lỗi cập nhật chi nhánh', 'Supabase', error as Error);
    }
  }

  async deleteLocation(uid: string, locationId: string): Promise<void> {
    try {
      const { error } = await supabase
        .from('locations')
        .delete()
        .eq('id', locationId)
        .eq('owner_id', uid);

      if (error) throw error;
    } catch (error) {
      throw new InfrastructureError('Lỗi xóa chi nhánh', 'Supabase', error as Error);
    }
  }

  listenLocations(uid: string, callback: (locations: any[]) => void): () => void {
    const channel = supabase
      .channel(`locations-${uid}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'locations',
          filter: `owner_id=eq.${uid}`
        },
        async () => {
          // Khi có thay đổi, fetch lại toàn bộ danh sách để đảm bảo tính nhất quán (hoặc tối ưu sau)
          const data = await this.getLocations(uid);
          callback(data);
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }
}
